import { render, staticRenderFns } from "./TipoPapelSelect.vue?vue&type=template&id=1f95ee26"
import script from "./TipoPapelSelect.vue?vue&type=script&lang=js"
export * from "./TipoPapelSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports